import ReactDOM from 'react-dom';

export const FrontPageCTAButtonsPortal = (props: { children: any }) => {
    const el = document.getElementById(
        'stofa-flows-front-page-cta-buttons-portal'
    );
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};

export const GlobalCartIconPortal = (props: { children: any }) => {
    const el = document.getElementById('stofa-flows-global-cart-icon-portal');
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};

export const GlobalCartIconPortalMobile = (props: { children: any }) => {
    const el = document.getElementById(
        'stofa-flows-global-cart-icon-portal-mobile'
    );
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};

export const MobileRaffleLinkPortal = (props: { children: any }) => {
    const el = document.getElementById('stofa-flows-mobile-raffle-portal');
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};

export const CartPortal = (props: { children: any }) => {
    const el = document.getElementById('stofa-flows-cart-portal');
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};

export const BroadbandPortal = (props: { children: any }) => {
    const el = document.getElementById('stofa-flows-broadband-portal');
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};

export const TVPortal = (props: { children: any }) => {
    const el = document.getElementById('stofa-flows-tv-portal');
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};

export const DAOFormPortal = (props: { children: any }) => {
    const el = document.getElementById('stofa-flows-dao-form-portal');
    if (el) {
        el.innerHTML = '';
        return ReactDOM.createPortal(props.children, el);
    } else {
        return null;
    }
};
